
import BaseErrorHandler from '../shared-lib/communication/BaseErrorHandler'
import { FormattedError } from '../shared-lib/communication/ErrorHelper'
import analytics from '../src/stores/analytics'

export default class ErrorHandler extends BaseErrorHandler {
  get location() {
    return this.store.router.pathname
  }

  get userId() {
    return this.store.applicationStore.applicationId || ''
  }

  showErrorInUI = (error: FormattedError) => {
    this.store.uiStore.showToast(error.message, 'error')
  }

  handleExpiredSession = () => {
    // No sessions on this platform
  }

  trackInAnalytics = (error: FormattedError) => {
    analytics.track('Error Message', { code: error.code, error })
  }

  expiredCodes = ['AUTH_TOKEN_EXPIRED', 'AUTH_HEADER_ERROR']
}
